import { cloneDeep } from "lodash";

import { INITIAL_STATE } from "./initialState";

const reducer = (state, action) => {
  const setState = (param) => {
    const newState = { ...state };
    newState[param] = action.data;
    return newState;
  };

  switch (action.type) {
    case "SET_HOURS": {
      return setState("hours");
    }
    case "RESET": {
      return cloneDeep(INITIAL_STATE);
    }
    default:
      throw new Error("Unhandled action type");
  }
};
export default reducer;
